import React, { useState } from "react";
import { Col, Row, Card, CardBody, Collapse, Tooltip } from "reactstrap";
import { Link } from "react-router-dom";
import Config from "config";
import {
  FiFileText,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiCalendar,
} from "react-icons/fi";
const IdentificationCard = ({
  title,
  details,
  ids,
  listeData,
  isAccordionOpen: isAccordionOpenProp,
  setIsAccordionOpen: setIsAccordionOpenProp,
  tooltips = {},
  noListeDataBg,
}) => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  // state interne uniquement si prop non fournie
  const [internalOpen, setInternalOpen] = useState(
    typeof isAccordionOpenProp === "boolean" ? isAccordionOpenProp : true
  );

  const isControlled = typeof isAccordionOpenProp === "boolean";

  const isAccordionOpen = isControlled ? isAccordionOpenProp : internalOpen;
  const setIsAccordionOpen = isControlled
    ? setIsAccordionOpenProp
    : setInternalOpen;

  const toggleAccordion = () => {
    setIsAccordionOpen((prev) => !prev);
  };
  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleTooltip = (key) => {
    setTooltipOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  function sanitizeSelector(str) {
    let sanitized = str.replace(/[^a-zA-Z0-9_-]/g, "_");
    if (/^\d/.test(sanitized)) {
      sanitized = "_" + sanitized;
    }
    return sanitized;
  }

  // SVG Icons inline
  const UserIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );

  const LinkIcon = ({ size = 12 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  );

  const InfoIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ verticalAlign: "middle" }}
    >
      <circle cx="12" cy="12" r="10" />
      <path fill="#fff" d="M11 11h2v6h-2zm0-4h2v2h-2z" />
    </svg>
  );

  return (
    <Card
      className="shadow-sm border-0 overflow-hidden mb-4"
      style={{ borderRadius: "12px" }}
    >
      {/* En-tête cliquable */}
      <div
        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
        style={{
          background: "#555B21",
          letterSpacing: "0.5px",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={toggleAccordion}
      >
        <div className="d-flex align-items-center">
          {/* <span style={{ marginRight: "8px" }}>
            <UserIcon />
          </span> */}
          <span style={{ fontSize: "0.82rem" }}>{title}</span>
        </div>
        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
          {isAccordionOpen ? (
            <FiChevronUp size={16} />
          ) : (
            <FiChevronDown size={16} />
          )}
        </span>
      </div>

      {/* Contenu repliable */}
      <Collapse isOpen={isAccordionOpen}>
        <CardBody className="p-0">
          {listeData && (
            <div className="px-2 py-2" style={noListeDataBg ? {} : { backgroundColor: "#f8f9fa" }}>
              {listeData()}
            </div>
          )}

          <div className="fields-container" style={{ paddingBottom: "8px" }}>
            {Object.entries(details).map(([key, value], index) => {
              const safeKey = sanitizeSelector(key.replace(/([:])/g, "\\$1"));

              return (
                <div
                  key={index}
                  className="field-item px-2 py-1"
                  style={{
                    backgroundColor: "white",
                    transition: "all 0.15s ease",
                    borderLeft: "3px solid transparent",
                    position: "relative",
                    cursor: "default",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e3f2fd";
                    e.currentTarget.style.borderLeftColor = "#007bff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white";
                    e.currentTarget.style.borderLeftColor = "transparent";
                  }}
                >
                  {/* Ligne de séparation subtile */}
                  {index > 0 && (
                    <div
                      className="field-separator"
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        right: 0,
                        height: "1px",
                        background:
                          "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                      }}
                    />
                  )}

                  <Row className="align-items-center g-1">
                    {/* Label avec tooltip optimisé */}
                    <Col xs={12} md={12} lg={4} className="field-label">
                      <div
                        className="d-flex align-items-center small text-muted"
                        style={{
                          minWidth: 0,
                          gap: "4px",
                        }}
                      >
                        <span
                          className="fw-medium"
                          style={{
                            fontSize: "0.7rem",
                            letterSpacing: "0.2px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            minWidth: 0,
                            flex: "1 1 auto",
                            display: "block",
                          }}
                          title={key}
                        >
                          {key}
                        </span>

                        {tooltips[key] && (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minWidth: "20px",
                              height: "20px",
                              cursor: "pointer",
                              flexShrink: 0,
                              color: "#17a2b8",
                            }}
                            id={`Info-${safeKey}`}
                          >
                            <InfoIcon />
                          </span>
                        )}

                        <span
                          className="text-primary"
                          style={{
                            flexShrink: 0,
                            marginLeft: tooltips[key] ? "0" : "auto",
                          }}
                        >
                          :
                        </span>

                        {/* Tooltip avec placement optimisé */}
                        {tooltips[key] && (
                          <Tooltip
                            placement="right-start"
                            isOpen={tooltipOpen[key]}
                            target={`Info-${safeKey}`}
                            toggle={() => toggleTooltip(key)}
                            delay={{ show: 0, hide: 100 }}
                            modifiers={[
                              {
                                name: "offset",
                                options: {
                                  offset: [0, 8],
                                },
                              },
                              {
                                name: "preventOverflow",
                                options: {
                                  boundary: "viewport",
                                  padding: 8,
                                },
                              },
                            ]}
                            style={{
                              maxWidth: "300px",
                              fontSize: "0.75rem",
                              textAlign: "left",
                            }}
                          >
                            {tooltips[key]}
                          </Tooltip>
                        )}
                      </div>
                    </Col>

                    {/* Valeur */}
                    <Col xs={12} md={12} lg={8} className="field-value">
                      <div
                        style={{
                          fontSize: "0.8rem",
                          padding: "3px 6px",
                          borderRadius: "6px",
                          backgroundColor: "#fff",
                          transition: "all 0.2s ease",
                          minHeight: "26px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {renderValue(key, value, ids, api, backUrl, LinkIcon)}
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        </CardBody>
      </Collapse>
    </Card>
  );
};

const renderValue = (key, value, ids, api, backUrl, LinkIcon) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return <span className="text-muted fst-italic">—</span>;
  }

  // Component pour les liens
  const LinkWrapper = ({ to, children }) => (
    <Link
      to={to}
      className="text-decoration-none fw-medium text-primary d-inline-flex align-items-center"
      style={{
        transition: "all 0.2s ease",
        fontSize: "0.8rem",
        padding: "4px 8px",
        borderRadius: "6px",
        backgroundColor: "#f8f9fa",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#e3f2fd";
        e.currentTarget.style.transform = "scale(1.02)";
        e.currentTarget.style.boxShadow = "0 0 0 2px rgba(13, 110, 253, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#f8f9fa";
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <span style={{ marginRight: "4px" }}>
        <LinkIcon size={9} />
      </span>
      {children}
    </Link>
  );

  // Formattage des nombres
  const formatNum = (val) => {
    return (
      <span
        style={{
          fontSize: "0.8rem",
          marginLeft: "auto",
          textAlign: "right",
          display: "block",
        }}
      >
        {val
          .toLocaleString("fr-FR", {
            style: "currency",
            currency: "EUR",
          })
          .replace("€", "")}
      </span>
    );
  };

  // Gestion des nombres
  if (typeof value === "number" && key !== "Builder" && key !== "Port" && key !== "Ordre") {
    // si la clé contient un %
    if (key.includes("%")) {
      return (
        <span
          style={{
            fontSize: "0.8rem",
            marginLeft: "auto",
            textAlign: "right",
            display: "block",
          }}
        >
          {value.toLocaleString("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}{" "}
          %
        </span>
      );
    }

    // sinon, comportement actuel (montant)
    return formatNum(value);
  }

  // Objet social avec style spécial
  if (key === "Objet social") {
    return (
      <span
        style={{
          paddingLeft: "40px",
          display: "flex",
          whiteSpace: "pretty",
        }}
      >
        {value}
      </span>
    );
  }

  // HTML content
  if (
    key === "Comptes associés" ||
    key === "Message"
    // || key === "Partenaire"
  ) {
    return (
      <span>
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </span>
    );
  }

  // Liens vers différentes ressources
  if (key === "Modèle" && ids?.publipostage_id != null) {
    return (
      <LinkWrapper
        to={`http://www.fluxod.com/${api}/publipostages/${ids.publipostage_id}/redirect_to_real_controller`}
      >
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Partenaire" && (ids?.partenaire_id || ids?.Partenaire) != null) {
    return (
      <LinkWrapper
        to={`http://www.fluxod.com/${api}/partenaires/${
          ids?.partenaire_id || ids?.Partenaire
        }/redirect_to_real_controller`}
      >
        {value}
      </LinkWrapper>
    );
  }
  if (key === "Exploitant" && ids?.partenaire2_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/partenaires_exploitants/${ids.partenaire2_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Investisseur" && ids?.investisseur_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/investisseurs/${ids.investisseur_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Impression" && ids?.impression_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/impressions/${ids.impression_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "PME" && ids?.pme_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/pmes/${ids.pme_id}`}>{value}</LinkWrapper>
    );
  }

  if (key === "Souscription" && ids?.souscription_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/souscriptions/${ids.souscription_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Réservation" && ids?.reservation_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/reservations/${ids.reservation_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (key === "Projet" && ids?.projet_id != null) {
    return (
      <LinkWrapper to={`${backUrl}/projets/${ids.projet_id}`}>
        {value}
      </LinkWrapper>
    );
  }

  if (
    key === "Partenaire" &&
    typeof ids !== "object" &&
    ids?.includes(`${backUrl}`)
  ) {
    return <LinkWrapper to={`${ids}`}>{value}</LinkWrapper>;
  }

  // Badges pour les statuts
  const badges = {
    Validé: { bg: "linear-gradient(135deg, #28a745, #20c997)", color: "white" },
    Validée: {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    Finalisée: {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    "Dossier de souscription CGP": {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    "Dossier payé": {
      bg: "linear-gradient(135deg, #28a745, #20c997)",
      color: "white",
    },
    Oui: { bg: "linear-gradient(135deg, #28a745, #20c997)", color: "white" },
    "Dossier complet": {
      bg: "linear-gradient(135deg, #33A133, #28a745)",
      color: "white",
    },
    "Dossier validé": {
      bg: "linear-gradient(135deg, #66C266, #33A133)",
      color: "white",
    },
  };

  const pendingStates = [
    "En attente",
    "Commercialisation",
    "Optionnelle - à confirmer",
    "En cours",
  ];

  const canceledStates = [
    "Ferme - en attente d'allocation",
    "Ferme - Rompu à rembourser",
    "Abandonnée",
    "Radiée",
    "Annulée",
    "Cloturée",
    "Non",
  ];

  if (badges[value]) {
    const style = badges[value];
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: style.bg,
          color: style.color,
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  if (pendingStates.includes(value)) {
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: "linear-gradient(135deg, #17a2b8, #6f42c1)",
          color: "white",
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  if (canceledStates.includes(value)) {
    return (
      <span
        className="badge px-2 py-1"
        style={{
          background: "linear-gradient(135deg, #dc3545, #fd7e14)",
          color: "white",
          fontSize: "0.65rem",
          fontWeight: "600",
          borderRadius: "8px",
          textTransform: "uppercase",
          letterSpacing: "0.2px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        }}
      >
        {value}
      </span>
    );
  }

  // fichier string url ou objet (url, filename)
  if (key === "Fichier") {
    const href = typeof value === "object" && value !== null ? value.url : value;
    const label = typeof value === "object" && value !== null && value.filename
      ? value.filename
      : "Télécharger";
    if (href && typeof href === "string") {
      return (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="btn btn-sm btn-soft-primary"
        >
          <i className="bx bx-download me-1"></i>{label}
        </a>
      );
    }
    return <span className="text-muted fst-italic">—</span>;
  }

  // Valeur par défaut avec la gestion des retours à la ligne
  return (
    <span
      className="text-dark"
      style={{ fontSize: "0.8rem", fontFamily: "sans-serif", whiteSpace: "pre-line" }}
    >
      {value}
    </span>
  );
};

export default IdentificationCard;
